module.exports = __webpack_public_path__ + "static/media/version_bg.eac0f120.jpg";